export default __webpack_public_path__ + "static/sirio-5-07a40e7ee3b71ebc06b1b102d45b4f3c.jpg";